import _ from 'lodash'

/**
 * Replaces placeholder tokens in text using the given array of substitutions.
 *
 * Example:
 * 	replacePlaceholders('The date is [today]',  [{ placeholder: 'today', value: '7/23/2018' }])
 *
 * Returns: "The date is 7/23/2018"
 */
function replacePlaceholders (text, substitutions, options = {}) {
	if (_.isNil(text)) {
		return ''
	}

	if (_.isEmpty(substitutions)) {
		return text
	}

	substitutions = substitutions.map(sub => {
		return {
			placeholder: sub.placeholder.toLowerCase(),
			value: sub.value
		}
	})

	let placeholders = substitutions.map(sub => _.escape(sub.placeholder)).join('|')

	let regex = new RegExp(regexPrefix + placeholders + regexSuffix, 'gi')

	return text.replace(regex, (match, prefix, taglessPrefix, tag, suffix) => {
		let value = _.find(substitutions, s => s.placeholder == tag.toLowerCase()).value

		let replacementText = options.plainText
			? value
			: `<span class="placeholder">${_.escape(value)}</span>`

		return (prefix || '') + replacementText + (suffix || '')
	})
}

const regexPrefix = "\\[(<(.*?)>)?("

const regexSuffix = ")(<(.*?)>)?\\]"

export default replacePlaceholders

replacePlaceholders.__filename__ = 'templates/replace-placeholders.js'
